import ReactGA from 'react-ga4';

// Replace 'G-XXXXXXXXXX' with your actual Google Analytics Measurement ID
const TRACKING_ID = 'G-C6R62GX1KL';

// Initialize Google Analytics
const initGA = () => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.initialize(TRACKING_ID);
  }
};

// Track page views
export const trackPageView = (path) => {
  if (process.env.NODE_ENV === 'production') {
    ReactGA.send({ hitType: "pageview", page: path });
  }
};

export default initGA;
